import React from 'react'

import { ItemCategoryFragment } from 'src/graphql'

import { CampaignRibbon } from '../'

interface Props {
  category: Pick<ItemCategoryFragment, 'id' | 'name' | 'items'>
  onPreview: (id: string) => void
  onPurchase: (id: string) => void
  onSelectCategory?: (id: string) => void
  isScrollBarEnabled: boolean
  isSeeAllButtonEnabled: boolean
  isWrapContentEnabled: boolean
}

const CampaignList: React.FC<Props> = props => {
  const {
    category,
    onPreview,
    onPurchase,
    isScrollBarEnabled,
    isSeeAllButtonEnabled,
    onSelectCategory,
    isWrapContentEnabled,
  } = props

  return (
    <CampaignRibbon
      items={category.items}
      isScrollBarEnabled={isScrollBarEnabled}
      title={category.name}
      handleCategoryClick={
        onSelectCategory ? () => onSelectCategory(category.id) : undefined
      }
      isSeeAllButtonEnabled={isSeeAllButtonEnabled}
      shouldWrapContent={isWrapContentEnabled}
      onItemClick={item => onPreview(item.id)}
      onPurchase={item => onPurchase(item.id)}
    />
  )
}

export default CampaignList
